import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { FileText } from "lucide-react"

export function TransferPreview() {
  return (
    <Card className="bg-white rounded-3xl shadow-lg p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <Button variant="ghost" size="sm" className="text-gray-500 -ml-2">
            关闭
          </Button>
        </div>
      </div>

      <div className="space-y-4">
        <h2 className="text-2xl font-bold text-gray-900">传输预览</h2>
        <p className="text-sm text-gray-600">1 文件 | 118.39 MB | 过期时间 2025-10-29 08:36:53</p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
          <div className="flex items-center gap-3">
            <FileText className="w-8 h-8 text-gray-400" />
            <div>
              <p className="text-sm font-medium text-gray-900">PromptOptimizer-2.1.0-linux-x86_64.AppImage</p>
              <p className="text-xs text-gray-500">118.39 MB</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm font-medium text-gray-900">23 小时后到期</p>
          </div>
        </div>
      </div>
    </Card>
  )
}
